// NC zip to county (largest land share, 2020 Census ZCTA-county file), service-area counties only.
export const ZIP_COUNTY = {
  Edgecombe: "27801 27809 27815 27819 27843 27852 27864 27881 27886",
  Franklin: "27508 27525 27549 27596 27816",
  Granville: "27507 27509 27522 27565 27581 27582",
  Halifax: "27823 27839 27844 27850 27870 27874 27890",
  Johnston: "27504 27520 27524 27527 27542 27555 27568 27569 27576 27577 27593",
  Nash: "27557 27803 27804 27807 27856 27878 27882 27891",
  Pitt: "27812 27827 27828 27829 27834 27837 27858 27879 27884 28513 28530 28590",
  Vance: "27536 27537 27544 27556 27584",
  Wake: "27502 27511 27513 27518 27519 27529 27539 27540 27545 27560 27571 27587 27591 27592 27597 27601 27603 27604 27605 27606 27607 27608 27609 27610 27612 27613 27614 27615 27616 27617 27695 27697",
  Wayne: "27530 27531 27533 27534 27830 27863 28333 28578",
  Wilson: "27813 27822 27851 27873 27880 27883 27893 27896",
};
